import styled, { keyframes, css } from "styled-components";
import linhasVerticais from "../images/linhas-verticais.png";
import simboloGafisa from "../images/simbolo-gafisa.svg";
import empreendimentoImage from "../images/MNO_03_Fachada_Detalhe_EF2_B_1.png";
import empreendimentoThumb from "../images/Vaga_REV04HR_1.png";
import empreendimentoThumbBig from "../images/Terraco_REV04HR_1.png";
import empreendimentoMapa from "../images/mapa.svg";
import mapaPath from "../images/path-map.svg";
import btFechar from "../images/bt-fechar.svg";
import btZoom from "../images/bt-zoom.svg";

// Stage px -> screen px. The 1920x1080 canvas is scaled by --stage-scale
// (min(vw/1920, vh/1080)), so anything drawn OUTSIDE that canvas — the fixed,
// full-window video overlays — must scale by hand or it renders at raw device
// px: identical physical size on a 4K screen, i.e. half the relative size, so
// twice as many thumbs fit per row. Sizing in stage px keeps the overlays
// looking identical on Full HD and 4K.
const sp = (n) => `calc(${n}px * var(--stage-scale, 1))`;

// Dark scrollbar matching the video overlays' near-black background.
const darkScrollbar = css`
  scrollbar-width: thin;
  scrollbar-color: rgba(255, 255, 255, 0.28) rgba(255, 255, 255, 0.06);

  &::-webkit-scrollbar {
    width: ${sp(8)};
  }

  &::-webkit-scrollbar-track {
    background: rgba(255, 255, 255, 0.06);
    border-radius: ${sp(4)};
  }

  &::-webkit-scrollbar-thumb {
    background: rgba(255, 255, 255, 0.28);
    border-radius: ${sp(4)};
  }

  &::-webkit-scrollbar-thumb:hover {
    background: rgba(255, 255, 255, 0.4);
  }
`;

export const lightAnimation = keyframes`
 0% { opacity:0; }
 50% { opacity:1; }
 100% { opacity:0; }
`;

// Transparent — the background now lives on the Stage (single full-window plane).
export const EmpreendimentoContainer = styled.div`
  position: absolute;
  width: 1920px;
  height: 1080px;
  left: 0px;
  top: 0px;
`;

// Background + pulse moved to the Stage; this layer is no longer needed.
export const EmpreendimentoContainerBackground = styled.div`
  display: none;
`;

export const LogoGafisa = styled.div`
  pointer-events: none;
  position: absolute;
  width: 32px;
  height: 27.62px;
  left: 3.85%;
  top: 22.5%;
  mix-blend-mode: normal;
  background-image: url(${simboloGafisa});
  background-size: contain;
  background-repeat: no-repeat;
  background-position: left center;
  opacity: 0;
  transition: all 1s ease-in-out 0s;

  &.in {
    pointer-events: all;
    opacity: 1;
    transition: all 1s ease-in-out 1s;
  }
`;

// Fallback for the top-left spot when no client logo is uploaded: a HOME icon
// (the spot links to "/"). Themed via the app font color, same position/anim as
// the logo.
export const HomeButton = styled.div`
  pointer-events: none;
  position: absolute;
  width: 32px;
  height: 32px;
  left: 3.85%;
  top: 22.5%;
  display: flex;
  align-items: center;
  justify-content: center;
  color: var(--app-font-color, #ffffff);
  opacity: 0;
  transition: all 1s ease-in-out 0s;

  svg {
    width: 32px;
    height: 32px;
    display: block;
  }

  &.in {
    pointer-events: all;
    opacity: 1;
    transition: all 1s ease-in-out 1s;
  }
`;

export const EmpreendimentoTitle = styled.div`
  pointer-events: none;
  user-select: none;
  position: absolute;
  display: flex;
  flex-flow: column wrap;
  justify-content: flex-end;
  width: 550px;
  height: 155px;
  left: 168px;
  top: 13px;

  color: var(--app-font-color, #ffffff);
  opacity: 0;
  transition: all 0.4s ease-in-out 0s;

  .text {
    width: 100%;
    height: auto;
    flex-basis: auto;
    align-self: flex-end;
    font-family: var(--app-font-family, "DM Sans", sans-serif);
    font-style: normal;
    font-weight: normal;
    font-size: 50px;
    line-height: 50px;
    text-transform: uppercase;
  }

  /* Logo variant of the title: occupies the same box and aligns bottom-left,
     matching the text title's placement. Contained so any aspect ratio fits. */
  .logo {
    width: 100%;
    height: 110px;
    flex-basis: auto;
    /* Cross axis (this container is a column): keep the box left-aligned so a
       narrower logo width doesn't drift right. */
    align-self: flex-start;
    background-repeat: no-repeat;
    background-position: left bottom;
    background-size: contain;
  }

  &.in {
    opacity: 1;
    left: 175px;
    top: 53px;
    transition: all 0.4s ease-in-out 0.5s;
  }

  &.inMap {
    opacity: 1;
    left: 245px;
    top: 12px;
    transition: all 0.8s ease-in-out 0.2s;

    .text {
      width: 100%;
      height: auto;
      flex-basis: auto;
      align-self: flex-end;
      font-family: var(--app-font-family, "DM Sans", sans-serif);
      font-style: normal;
      font-weight: normal;
      font-size: 40px;
      line-height: 40px;
      text-transform: uppercase;
    }
  }

  .sub {
    width: 100%;
    height: 20px;
    flexis-basis: auto;
    font-family: var(--app-font-family, "DM Sans", sans-serif);
    font-style: normal;
    font-weight: 500;
    font-size: 20px;
    line-height: 20px;
    text-transform: capitalize;
  }
`;

export const EmpreendimentoQr = styled.div`
  position: absolute;
  width: 61px;
  height: 61px;
  left: 147px;
  top: 226px;

  background: #ffffff;
  background-size: 85%;
  background-repeat: no-repeat;
  background-position: center center;
  border-radius: 4px;

  opacity: 0;
  transition: all 0.7s ease-in-out 0s;

  &.in {
    opacity: 1;
    left: 177px;
    top: 226px;
    transition: all 0.7s ease-in-out 0.4s;
  }
`;

export const EmpreendimentoAddress = styled.div`
  pointer-events: none;
  user-select: none;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  padding: 0px;
  position: absolute;
  width: 550px;
  height: 62px;
  left: 230px;
  top: 227px;
  font-family: var(--app-font-family-secondary, "Space Mono", monospace);
  font-style: normal;
  font-weight: normal;
  font-size: 12px;
  line-height: 18px;
  color: var(--app-font-color, #ffffff);
  opacity: 0;
  transition: all 0.7s ease-in-out 0s;

  &.in {
    opacity: 1;
    left: 260px;
    top: 227px;
    transition: all 0.7s ease-in-out 0.6s;
  }

  &.inMap {
    opacity: 1;
    left: 245px;
    top: 180px;
    transition: all 0.7s ease-in-out 0.4s;
  }
`;

export const EmpreendimentoAddressDetails = styled.div`
  pointer-events: none;
  user-select: none;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  padding: 0px;
  position: absolute;
  width: 184px;
  height: 62px;
  left: -20px;
  top: 20px;
  font-family: var(--app-font-family-secondary, "Space Mono", monospace);
  font-style: normal;
  font-weight: normal;
  font-size: 12px;
  line-height: 18px;
  color: var(--app-font-color-muted, #c6c6c6);
  opacity: 0;
  transition: all 0.7s ease-in-out 0s;

  &.in {
    opacity: 1;
    left: 0px;
    top: 20px;
    transition: all 0.7s ease-in-out 0s;
  }
`;

export const EmpreendimentoUnits = styled.div`
  pointer-events: none;
  position: absolute;
  width: 86px;
  height: 104px;
  left: 437px;
  top: 195px;
  color: var(--app-font-color, #ffffff);
  opacity: 0;
  transition: all 0.7s ease-in-out 0s;

  &.in {
    opacity: 1;
    transition: all 0.7s ease-in-out 0.4s;
  }
`;

export const UnitsNumber = styled.div`
  pointer-events: none;
  position: absolute;
  width: 140px;
  margin-left: -47px;
  font-family: var(--app-font-family-secondary, "Space Mono", monospace);
  font-style: normal;
  font-weight: normal;
  font-size: 70px;
  line-height: 104px;
  text-align: right;
`;

export const UnitsText = styled.div`
  pointer-events: none;
  position: absolute;
  width: 166px;
  height: 64px;
  left: 100px;
  top: 20px;
  font-family: var(--app-font-family, "DM Sans", sans-serif);
  font-style: normal;
  font-weight: normal;
  font-size: 32px;
  line-height: 32px;
  text-align: left;
  z-index: 10;
`;

export const UnitsCircle = styled.div`
  pointer-events: none;
  position: absolute;
  width: 102px;
  height: 102px;
  left: 200px;
  top: 105px;
`;

export const EmpreendimentoImagem = styled.div`
  pointer-events: none;
  position: absolute;
  width: 698px;
  height: 465px;
  left: -40px;
  top: 359px;
  background-image: url(${empreendimentoImage});
  background-size: cover;
  background-position: center center;
  background-repeat: no-repeat;
  border-radius: 0px 8px 8px 0px;
  z-index: 10;
  opacity: 0;
  transition: all 0.7s ease-in-out 0s;

  &.in {
    pointer-events: all;
    opacity: 1;
    left: 0px;
    top: 359px;
    transition: all 0.7s ease-in-out 0.6s;
  }
`;

export const EmpreendimentoPorcentagem = styled.div`
  pointer-events: none;
  position: absolute;
  width: 150px;
  left: 715px;
  top: 359px;
  opacity: 0;
  transition: all 0.7s ease-in-out 0s;

  &.in {
    opacity: 1;
    transition: all 0.7s ease-in-out 0.6s;
  }

  .number {
    position: absolute;
    width: 8px;
    height: 9px;
    left: 20px;
    top: 470px;

    font-family: var(--app-font-family-secondary, "Space Mono", monospace);
    font-style: normal;
    font-weight: normal;
    font-size: 6px;
    line-height: 9px;
    /* identical to box height */

    color: var(--app-font-color, #ffffff);
  }

  .number2 {
    position: absolute;
    width: 8px;
    height: 9px;
    left: 0px;
    top: 470px;

    font-family: var(--app-font-family-secondary, "Space Mono", monospace);
    font-style: normal;
    font-weight: normal;
    font-size: 6px;
    line-height: 9px;
    /* identical to box height */

    color: var(--app-font-color, #ffffff);
  }

  .text {
    position: absolute;
    width: 89px;
    height: 24px;
    left: 20px;
    top: 38px;
    font-family: var(--app-font-family-secondary, "Space Mono", monospace);
    font-style: normal;
    font-weight: normal;
    font-size: 16px;
    line-height: 24px;
    color: var(--app-font-color-muted, #c6c6c6);
  }
`;

export const EmpreendimentoPorcentagemBarra = styled.div`
  pointer-events: none;
  position: absolute;
  width: 9px;
  height: 465px;
  left: 20px;
  border-radius: 4px;
  background: linear-gradient(180deg, rgba(45, 45, 45, 0) 0%, #2d2d2d 100%);
  #empreendimento-porcentagem {
    position: absolute;
    width: 100%;
    height: 0%;
    bottom: 0px;
    border-radius: 4px;
    background: linear-gradient(
      180deg,
      #ff005d 0%,
      rgba(255, 79, 143, 0.47) 100%
    );
    transition: all 1s ease-in-out;
  }
`;

export const EmpreendimentoPorcentagemBarra2 = styled.div`
  pointer-events: none;
  position: absolute;
  width: 9px;
  height: 465px;
  left: 0px;
  border-radius: 4px;
  background: linear-gradient(180deg, rgba(45, 45, 45, 0) 0%, #2d2d2d 100%);
  #empreendimento-porcentagem2 {
    position: absolute;
    width: 100%;
    height: 0%;
    bottom: 0px;
    border-radius: 4px;
    background: linear-gradient(
      180deg,
      #ff005d 0%,
      rgba(255, 79, 143, 0.47) 100%
    );
    transition: all 1s ease-in-out;
  }
`;

export const EmpreendimentoDescription = styled.div`
  pointer-events: none;
  user-select: none;
  position: absolute;
  /* Below the main image (image spans x0–698, bottom at y824), widened to run
     along the image's bottom edge. */
  width: 522px;
  height: 90px;
  left: 176px;
  top: 871px;

  /* Admin-authored rich text uses the secondary/accent font (admin Config). */
  font-family: var(--app-font-family-secondary, "Space Mono", monospace);
  font-style: normal;
  font-weight: 500;
  font-size: 14px;
  line-height: 18px;

  color: #8a8a8a;
  opacity: 0;
  transition: all 1s ease-in-out 0s;

  &.in {
    opacity: 1;
    transition: all 1s ease-in-out 0.8s;
  }

  /* Preserve admin-authored rich text (bold / italic / lists / breaks). */
  p {
    margin: 0 0 8px;
  }
  p:last-child {
    margin-bottom: 0;
  }
  strong,
  b {
    font-weight: 700;
  }
  em,
  i {
    font-style: italic;
  }
  u {
    text-decoration: underline;
  }
  ul,
  ol {
    margin: 0 0 8px;
    padding-left: 18px;
  }
  a {
    color: inherit;
  }
`;

export const EmpreendimentosPlantas = styled.div`
  pointer-events: none;
  flex: 1 1 auto;
  // background-color: pink;
  overflow-y: auto;
  flex-flow: column wrap;
  justify-content: flex-start !important;
  align-items: left;
  align-content: flex-start !important;
  position: absolute;
  width: 360px;
  height: 800px;
  min-height: 0px;
  max-height: 800px;
  left: 820px;
  bottom: 30px;
  overflow-x: visible;
  overflow-y: auto;
  scroll-behavior: smooth;
  opacity: 0;
  transform: translateX(-50px);
  padding-top: 60px;
  padding-bottom: 60px;
  box-sizing: border-box;
  z-index: 0;
  transition: all 1s ease-in-out 0s;

  &::-webkit-scrollbar {
    display: none;
    transition: all 1s ease-in-out 0.8s;
  }

  &.in {
    pointer-events: all;
    opacity: 1;
    left: 820px;
    bottom: 30px;
    transform: translateX(0px);
    min-height: 0px;
    max-height: 800px;
    transition: all 1s ease-in-out 0.8s;
  }
`;

export const EmpreendimentosPlantasDegrade = styled.div`
  pointer-events: none;
  position: absolute;
  width: 360px;
  height: 800px;
  left: 820px;
  bottom: 30px;
  opacity: 0;
  transform: translateX(-50px);
  transition: all 1s ease-in-out 0s;
  z-index: 100;
  /* Top + bottom fade over the plantas navigation: the configured background
     color fading to that same color at alpha 0 (CSS vars set by the Stage). */
  background: linear-gradient(
      180deg,
      var(--app-bg-color, #141414) 2%,
      var(--app-bg-color-0, rgba(20, 20, 20, 0)) 20%
    ),
    linear-gradient(
      180deg,
      var(--app-bg-color-0, rgba(20, 20, 20, 0)) 80%,
      var(--app-bg-color, #141414) 98%
    );

  &.in {
    opacity: 1;
    transform: translateX(0px);
    transition: all 1s ease-in-out 0.8s;
  }
`;

export const EmpreendimentosPlantasThumb = styled.div`
  box-sizing: border-box;
  /* The .title/.text captions are absolutely positioned at left:190px (to the
     right of the image). Anchor them to THIS card — without a positioned
     ancestor here they resolve against the EmpreendimentosPlantas container and
     drift one row down, so each caption landed beside the next thumb (and the
     first thumb showed none). */
  position: relative;
  width: 183px;
  height: 106px;
  align-self: flex-start;
  margin-top: 5px;
  margin-bottom: 5px;
  border-radius: 8px;
  background-color: black;
  /* Must stay visible: the .title/.text captions sit at left:190px, outside the
     183px image box. Clipping here (overflow:hidden) would hide them. The image
     keeps its rounded corners via border-radius on .planta-bg below. */
  overflow: visible;

  /* Camada da imagem da planta (o background vem inline no JSX). Fica separada
     dos rótulos .title/.text para que o mix-blend-mode "multiply" (opcional,
     via config) afete só a imagem e não escureça o texto ao lado. */
  .planta-bg {
    width: 100%;
    height: 100%;
    border-radius: 8px;
    overflow: hidden;
    box-sizing: border-box;
    padding: 0;
    /* contain (não 135% zoom) mostra a planta inteira; padding + origin no
       content-box afastam a imagem das bordas para os cantos não serem cortados. */
    background-origin: content-box;
    background-size: contain;
    background-position: center center;
    background-repeat: no-repeat;
  }

  /* Ativado por className "multiply" quando o cliente liga a opção no admin.
     O tile inteiro recebe mix-blend-mode: multiply contra o fundo da página,
     então o fundo branco da planta some (fica "transparente") e só o traço
     permanece. Padding interno afasta o desenho das bordas. */
  &.multiply {
    /* Fundo do tile = fundo do app: dá à imagem um backdrop real (o painel de
       plantas é uma camada isolada por transform/opacity, então um blend no
       tile não alcançaria o fundo da página). A imagem multiplica contra ele,
       fazendo o branco da planta sumir no fundo — só o traço permanece. */
    background-color: var(--app-bg-color, #141414);
    padding: 4px;
  }
  &.multiply .planta-bg {
    mix-blend-mode: multiply;
  }

  .title {
    pointer-events: none;
    position: absolute;
    top: 0;
    width: 165px;
    height: 90px;
    left: 190px;
    display: flex;
    align-content: flex-end;
    align-items: flex-end;
    font-family: var(--app-font-family-secondary, "Space Mono", monospace);
    font-style: normal;
    font-weight: normal;
    font-size: 12px;
    line-height: 18px;
    text-transform: uppercase;
    color: var(--app-font-color, #ffffff);
  }

  .text {
    pointer-events: none;
    position: absolute;
    top: 0;
    width: 165px;
    height: 18px;
    left: 190px;
    transform: translateY(90px);
    font-family: var(--app-font-family-secondary, "Space Mono", monospace);
    font-style: normal;
    font-weight: normal;
    font-size: 12px;
    line-height: 18px;
    color: var(--app-font-color-muted, #c6c6c6);
  }
`;

// Bottom-right gallery thumbs — a fixed-canvas positioning context. The tiles
// inside are absolutely positioned so they overlap like a stacked collage
// (small tiles behind, big tiles in front and offset to the right), exactly as
// the two original galleries looked. Only populated galleries are rendered.
export const EmpreendimentosThumbs = styled.div`
  pointer-events: none;
  position: absolute;
  width: 1000px;
  height: 272px;
  left: 1050px;
  top: 690px;
  opacity: 0;
  transition: all 1s ease-in-out 0s;

  &.in {
    pointer-events: all;
    opacity: 1;
    left: 1100px;
    top: 690px;
    transition: all 1s ease-in-out 0.6s;
  }
`;

// One gallery thumb. Absolutely positioned inside EmpreendimentosThumbs; its
// left/top/width/height/z-index and background image are set inline per tile
// (computed from its position in the populated-gallery list) so the tiles form
// an ascending staircase: smallest on the far left, each one to the right a bit
// bigger and in front. The title sits just below each tile (no clip — no
// overflow:hidden).
export const EmpreendimentoThumbTile = styled.div`
  position: absolute;
  cursor: pointer;
  border-radius: 8px;
  background-size: 160%;
  background-position: center center;
  /* Soft shadow toward the smaller tile behind (stack grows rightward in
     front), so overlapping tiles separate gently. */
  box-shadow: -12px 8px 24px rgba(0, 0, 0, 0.25);

  .text {
    position: absolute;
    left: 0px;
    top: 100%;
    margin-top: 7px;
    width: 350px;
    font-family: var(--app-font-family, "DM Sans", sans-serif);
    font-style: normal;
    font-weight: normal;
    font-size: 12px;
    line-height: 16px;
    color: var(--app-font-color, #ffffff);
  }
`;

export const EmpreendimentosThumbsThumb = styled.div`
  position: absolute;
  width: 363px;
  height: 250px;
  left: 130px;
  top: 11px;
  background-size: 160%;
  background-position: center center;
  background-image: linear-gradient(
      269.85deg,
      #141414 3.73%,
      rgba(20, 20, 20, 0) 86.62%
    ),
    url(${empreendimentoThumb});
  border-radius: 8px;

  .text {
    position: absolute;
    width: 350px;
    height: 16px;
    left: 0px;
    top: 257px;
    font-family: var(--app-font-family, "DM Sans", sans-serif);
    font-style: normal;
    font-weight: normal;
    font-size: 12px;
    line-height: 16px;
    color: var(--app-font-color, #ffffff);
  }
`;

export const EmpreendimentosThumbsThumbBig = styled.div`
  position: absolute;
  width: 389px;
  height: 272px;
  left: 350px;
  top: 0px;
  background-size: 160%;
  background-image: url(${empreendimentoThumbBig});
  background-position: center center;

  border-radius: 8px;
  .text {
    position: absolute;
    width: 350px;
    height: 16px;
    left: 0px;
    top: 279px;
    font-family: var(--app-font-family, "DM Sans", sans-serif);
    font-style: normal;
    font-weight: normal;
    font-size: 12px;
    line-height: 16px;
    color: var(--app-font-color, #ffffff);
  }
`;

export const EmpreendimentosMap = styled.div`
  position: absolute;
  width: 767.8px;
  height: 509px;
  left: 1248px;
  top: 0px;
  background-repeat: no-repeat;
  background-image: url(${empreendimentoMapa});
  opacity: 0;
  transform: scale(0.9);
  transition: all 1s ease-in-out 0s;

  &.in {
    transform: scale(1);
    opacity: 1;
    transition: all 1s ease-in-out 0.5s;
  }
`;

export const EmpreendimentosMapEmbed = styled.div`
  pointer-events: all;
  cursor: pointer;
  position: absolute;
  width: 567.39px;
  height: 567.39px;
  right: 56px;
  top: -200px;
  border-radius: 50%;
  background-color: #edbbdc;
  /* the map inside is always panel-sized and centred; this box clips it */
  overflow: hidden;
  isolation: isolate;
  transition: all 1s ease-in-out 0s;

  &.in {
    pointer-events: none;
    top: 0px;
    right: 100px;
    width: 960px;
    height: 1080px;
    border-radius: 0%;
    transition: border-radius 1s ease-in-out 0.5s, width 1s ease-in-out 0.5s,
      height 1s ease-in-out 0.5s, top 0.5s ease-in-outs,
      right 0.5s ease-in-out 0s;
  }
`;

export const EmpreendimentosMapPath = styled.div`
  pointer-events: none;
  position: absolute;
  width: 461px;
  height: 216px;
  left: -21px;
  top: 90px;
  background-image: url(${mapaPath});
  opacity: 1;
  transition: all 1s ease-in-out;

  /* hidden at once when the map opens (it points at the closed thumbnail) */
  &.off {
    opacity: 0;
    transition: none;
  }
`;

export const EmpreendimentosMapInterests = styled.div`
  position: absolute;
  /* 8px of side padding (box moved left by the same) so the selected item's
     pill, which extends 8px past the text, is not clipped by overflow */
  width: 286px;
  /* closed: reaches down to just above the gallery thumbnails (top 745px),
     the last rows fading out instead of being cut */
  height: 404px;
  left: -29px;
  top: 329px;
  padding: 0 8px 50px 8px;
  box-sizing: border-box;
  opacity: 1;
  overflow-x: hidden;
  overflow-y: scroll;
  transform: scale(1);
  transition: all 1s ease-in-out;
  -webkit-mask-image: linear-gradient(to bottom, #000 calc(100% - 48px), transparent 100%);
  mask-image: linear-gradient(to bottom, #000 calc(100% - 48px), transparent 100%);

  &::-webkit-scrollbar {
    display: none;
  }

  &.off {
    pointer-events: none;
    opacity: 0;
  }

  &.active {
    /* 286 = 270 + the 8px side padding, left moved by the same 8px: the
       text stays exactly where it was before the pill padding existed */
    width: 286px;
    height: 340px;
    left: -808px;
    top: 470px;
    transform: scale(2.5);
    opacity: 1;
    /* the open list has its own gradient overlay */
    -webkit-mask-image: none;
    mask-image: none;
  }
`;

export const EmpreendimentosMapInterestsItem = styled.div`
  cursor: pointer;
  user-select: none;
  display: flex;
  flex-flow: row nowrap;
  align-items: center;
  box-sizing: border-box;
  /* every item has the pill geometry (hugging the bullet and the title, 8px
     of padding, the text staying exactly where it was); only the colours
     toggle with .selected, so the fade in/out never shows a flat box */
  width: fit-content;
  max-width: 270px;
  padding: 0 8px;
  margin-left: -8px;
  border-radius: 12px;
  height: 21px;
  transition: all 1s ease-in-out 0s;

  &.active {
    height: 24px;
  }

  /* closed thumbnail: 14px rows; open map: 12px rows scaled 2.5x by the list */
  .meters {
    font-family: var(--app-font-family-secondary, "Space Mono", monospace);
    font-style: normal;
    font-weight: normal;
    font-size: 14px;
    line-height: 21px;
    color: var(--app-font-color, #ffffff);
    transition: all 1s ease-in-out 0s;

    &.active {
      font-size: 12px;
      line-height: 18px;
      color: var(--app-font-color-muted, #c6c6c6);
    }
  }
  .text {
    padding-left: 10px;
    width: auto;
    white-space: nowrap;
    height: 21px;
    font-family: var(--app-font-family, "DM Sans", sans-serif);
    font-style: normal;
    font-weight: normal;
    font-size: 14px;
    line-height: 21px;
    color: var(--app-font-color-muted, #c6c6c6);
    transition: all 1s ease-in-out 0s;

    &.active {
      height: 18px;
      font-size: 12px;
      line-height: 18px;
      color: var(--app-font-color, #ffffff);
    }
  }

  /* the atração whose route is on the map: an inverted pill (text colour as
     the background, background colour as the text) */
  &.selected {
    background: var(--app-font-color, #ffffff);
  }
  &.selected .text,
  &.selected .meters {
    color: var(--app-bg-color, #141414);
  }
  /* the highlight switches at once: a fade would drop frames while the map
     is busy fitting the route right after the tap; the open/close height
     change stays slow */
  &,
  .text,
  .meters {
    transition: height 1s ease-in-out 0s;
  }
`;

export const EmpreendimentosMapInterestsGradient = styled.div`
  pointer-events: none;
  position: fixed;
  z-index: 1;
  width: 922px;
  height: 285px;
  left: 0px;
  bottom: 0px;
  background: linear-gradient(
    180deg,
    var(--app-bg-color-0, rgba(20, 20, 20, 0)) 0%,
    var(--app-bg-color, #141414) 100%
  );
  opacity: 0;
  transition: all 1s ease-in-out 0s;

  &.active {
    opacity: 1;
  }
`;

export const EmpreendimentosMapCloseBt = styled.div`
  pointer-events: none;
  position: absolute;
  z-index: 10000;
  width: 53px;
  height: 53px;
  left: 110px;
  bottom: 50px;
  background-image: url(${btFechar});
  background-repeat: no-repeat;
  background-position: center center;
  background-size: cover;
  opacity: 0;
  transition: all 1s ease-in-out 0s;

  &.in {
    pointer-events: all;
    opacity: 1;
    transition: all 1s ease-in-out 1s;
  }
`;

const carouselContainerBase = css`
  pointer-events: none;
  position: absolute;
  width: 1920px;
  height: 1080px;
  z-index: 100;
  background-color: rgba(0, 0, 0, 0.8);
  /* Bleed the dim past the 1920×1080 box so it covers the whole window
     (letterbox included); box-shadow keeps the same 0.8 alpha, no overlap
     with the element's own box, so the dim stays uniform. */
  box-shadow: 0 0 0 10000px rgba(0, 0, 0, 0.8);
  touchaction: "none";
  opacity: 0;
  transition: all 0.3s ease-in-out;

  &.in {
    pointer-events: all;
    opacity: 1;
  }

  .css-1fzpoyk {
    height: auto;
  }

  .css-1qzevvg {
    margin-top: -70px;
    z-index: 100;
  }
`;

export const CarouselContainerFachada = styled.div`
  ${carouselContainerBase}
`;

export const CarouselContainerAreaComum = styled.div`
  ${carouselContainerBase}
`;

export const CarouselContainerPerspectivas = styled.div`
  ${carouselContainerBase}
`;

export const CarouselContainerPlantas = styled.div`
  ${carouselContainerBase}
`;

// Shared by the extra galleries (galeria-3, galeria-4) — one styled component
// rendered once per gallery.
export const CarouselContainerGaleria = styled.div`
  ${carouselContainerBase}
`;

export const CarouselCloseButton = styled.div`
  cursor: pointer;
  position: absolute;
  z-index: 10000;
  width: 53px;
  height: 53px;
  left: 891px;
  bottom: 27px;
  background-image: url(${btFechar});
  border: 1px solid #aaaaaa;
  border-radius: 50%;
`;

export const CarouselZoomButton = styled.div`
  cursor: pointer;
  position: absolute;
  z-index: 10000;
  width: 53px;
  height: 53px;
  left: 977px;
  bottom: 27px;
  background-image: url(${btZoom});
  border: 1px solid #aaaaaa;
  border-radius: 50%;
`;

export const PlantaInferiorButton = styled.div`
  user-select: none;
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  padding: 12px 32px;

  position: absolute;
  width: 147px;
  height: 45px;
  left: 987px;
  bottom: 20px;

  background: #f1f1f1;
  border-radius: 8px;

  font-family: var(--app-font-family, "DM Sans", sans-serif);
  font-style: normal;
  font-weight: 500;
  font-size: 16px;
  line-height: 21px;
  /* identical to box height */
  text-align: center;
  color: #000000;
  transition: all 0.3s ease-in-out;

  &.active {
    background: #ff0077;
    color: var(--app-font-color, #ffffff);
  }
`;

export const PlantaSuperiorButton = styled(PlantaInferiorButton)`
  left: 1198px;
`;

const imageContainerBase = css`
  display: flex;
  align-content: center;
  align-items: center;
  justify-content: center;
  pointer-events: none;
  position: absolute;
  width: 1920px;
  height: 1080px;
  z-index: 200;
  background-color: rgba(0, 0, 0, 1);
  /* Bleed the backdrop past the 1920×1080 box so it fills the whole window
     (the letterbox area) while the scaled image + buttons stay aligned. */
  box-shadow: 0 0 0 10000px rgba(0, 0, 0, 1);
  background-repeat: no-repeat;
  background-position: center center;
  background-size: contain;
  touchaction: "none";
  opacity: 0;
  transition: all 0.3s ease-in-out;
  object-fit: contain;

  &.in {
    pointer-events: all;
    opacity: 1;
  }

  img {
    pointer-events: none;
    user-select: none;
    user-drag: none;
    height: 100%;
  }
`;

// Small caption attached to the bottom of an opened image
// (perspectivas/fachada/área comum). Lives inside the image box so it drags
// and zooms together with the image.
export const ImageLegenda = styled.div`
  pointer-events: none;
  position: absolute;
  z-index: 10000;
  right: 32px;
  bottom: 24px;
  max-width: 45%;

  font-family: var(--app-font-family, "DM Sans", sans-serif);
  font-style: normal;
  font-weight: 500;
  font-size: 18px;
  line-height: 1.3;
  text-align: right;
  color: #ffffff;
  text-shadow: 0 1px 4px rgba(0, 0, 0, 0.85);
`;

export const ImageContainerFachada = styled.div`
  ${imageContainerBase}
`;

export const ImageContainerAreaComum = styled.div`
  ${imageContainerBase}
`;

export const ImageContainerPerspectivas = styled.div`
  ${imageContainerBase}
`;

export const ImageContainerPlantas = styled.div`
  ${imageContainerBase}
`;

// Shared by the extra galleries (galeria-3, galeria-4).
export const ImageContainerGaleria = styled.div`
  ${imageContainerBase}
`;

// Video poster thumbnails packed into the bottom-right corner of the main
// perspective image (EmpreendimentoImagem: left 0, top 359, 698×465 → corner
// at ~x698/y824). Anchored bottom-right so extra videos stack leftward. Fades
// in with the image (shares empreendimentoImagem's .in class).
export const VideoThumbs = styled.div`
  pointer-events: none;
  position: absolute;
  display: flex;
  flex-direction: row;
  flex-wrap: nowrap;
  justify-content: flex-end;
  align-items: flex-end;
  gap: 8px;
  right: 1190px; /* pin right edge ~730px, a bit past image's 698px corner; grows leftward */
  top: 766px;
  z-index: 11; /* above the image (z-index 10) */
  opacity: 0;
  transition: all 1s ease-in-out 0s;

  &.in {
    pointer-events: all;
    opacity: 1;
    transition: all 1s ease-in-out 0.6s;
  }
`;

export const VideoThumb = styled.div`
  cursor: pointer;
  user-select: none;
  position: relative;
  width: 142px;
  height: 80px;
  border-radius: 6px;
  overflow: hidden;
  background-size: cover;
  background-position: center;
  background-color: #000;
  box-shadow: 0 3px 20px rgba(0, 0, 0, 0.28);

  /* Centered play triangle. */
  &::after {
    content: "";
    position: absolute;
    left: 50%;
    top: 50%;
    transform: translate(-40%, -50%);
    width: 0;
    height: 0;
    border-style: solid;
    border-width: 11px 0 11px 18px;
    border-color: transparent transparent transparent #ffffff;
    filter: drop-shadow(0 1px 2px rgba(0, 0, 0, 0.7));
  }

  &:active {
    border-color: #ffffff;
  }

  .label {
    position: absolute;
    left: 0;
    right: 0;
    bottom: 0;
    padding: 3px 6px;
    background: linear-gradient(transparent, rgba(0, 0, 0, 0.8));
    font-family: var(--app-font-family, "DM Sans", sans-serif);
    font-style: normal;
    font-weight: 500;
    font-size: 11px;
    line-height: 1.2;
    color: #ffffff;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }
`;

// Full-window black overlay hosting the <video>. Same show/hide .in pattern.
export const VideoOverlay = styled.div`
  pointer-events: none;
  position: fixed;
  inset: 0;
  width: 100vw;
  height: 100vh;
  z-index: 100001;
  background-color: #000;
  opacity: 0;
  transition: opacity 0.3s ease-in-out;

  &.in {
    pointer-events: all;
    opacity: 1;
  }

  video {
    position: absolute;
    width: 100%;
    height: 100%;
    left: 0;
    top: 0;
    object-fit: contain;
    background: #000;
  }
`;

// Big, always-visible touch close button for the video overlay. Sits top-right
// (clear of the native <video> controls bar at the bottom) and above the video,
// so a touch kiosk always has a reliable way to exit — no native fullscreen.
export const VideoCloseButton = styled.div`
  cursor: pointer;
  position: absolute;
  z-index: 30000;
  top: calc(28px * var(--stage-scale, 1));
  right: calc(28px * var(--stage-scale, 1));
  width: calc(53px * var(--stage-scale, 1));
  height: calc(53px * var(--stage-scale, 1));
  border-radius: 50%;
  border: 1px solid #aaaaaa;
  background-image: url(${btFechar});
  background-repeat: no-repeat;
  background-position: center center;
  background-size: cover;
`;

// Full-window overlay that shows a single gallery's videos as a grid of poster
// thumbnails (legenda under each). Opened from the gallery's bottom-right tile
// when that gallery holds videos. Tapping a thumbnail plays it fullscreen via
// the VideoOverlay above (z 100001). Same fixed/portal pattern; sits just below
// the player so closing the player reveals the grid again.
export const VideoGridOverlay = styled.div`
  pointer-events: none;
  position: fixed;
  inset: 0;
  width: 100vw;
  height: 100vh;
  z-index: 100000;
  background-color: rgba(0, 0, 0, 0.92);
  opacity: 0;
  transition: opacity 0.3s ease-in-out;
  display: flex;
  align-items: center;
  justify-content: center;

  &.in {
    pointer-events: all;
    opacity: 1;
  }
`;

// Wrapping, scrollable grid of the gallery's video thumbnails. Rows are
// top-aligned (align-content: flex-start), NOT centered: when a gallery has
// many videos the grid overflows max-height and scrolls, and centered overflow
// would clip the top/bottom rows out of reach. The overlay still centers the
// grid box as a whole, so a few videos stay visually centered.
export const VideoGrid = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: ${sp(28)} ${sp(24)};
  justify-content: center;
  align-content: flex-start;
  /* Stage px, not vw/vh: same thumbs-per-row on Full HD and 4K. */
  max-width: ${sp(1600)};
  max-height: ${sp(760)};
  overflow-y: auto;
  -webkit-overflow-scrolling: touch;
  padding: ${sp(24)};
  /* clear the bottom control row (close + view toggle) */
  margin-bottom: ${sp(60)};
  ${darkScrollbar}
`;

// One video thumbnail: poster + centered play triangle, with its legenda in a
// caption BELOW the thumb.
export const VideoGridItem = styled.div`
  cursor: pointer;
  user-select: none;
  width: ${sp(300)};
  display: flex;
  flex-direction: column;
  gap: ${sp(10)};

  .thumb {
    position: relative;
    width: 100%;
    height: ${sp(169)};
    border-radius: ${sp(8)};
    overflow: hidden;
    background-size: cover;
    background-position: center;
    background-color: #000;
    box-shadow: 0 ${sp(4)} ${sp(24)} rgba(0, 0, 0, 0.45);
  }

  .thumb::after {
    content: "";
    position: absolute;
    left: 50%;
    top: 50%;
    transform: translate(-40%, -50%);
    width: 0;
    height: 0;
    border-style: solid;
    border-width: ${sp(16)} 0 ${sp(16)} ${sp(26)};
    border-color: transparent transparent transparent #ffffff;
    filter: drop-shadow(0 1px 3px rgba(0, 0, 0, 0.7));
  }

  &:active .thumb {
    outline: ${sp(2)} solid #ffffff;
  }

  .caption {
    font-family: var(--app-font-family, "DM Sans", sans-serif);
    font-weight: 500;
    font-size: ${sp(16)};
    line-height: 1.25;
    color: #ffffff;
    text-align: center;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }
`;

// Bottom-centered control row of the gallery-video overlay: close + view
// toggle, side by side. Mirrors the carousels, where the close and zoom circles
// sit together at the bottom (left 891/977, bottom 27 on the 1920 canvas — 53px
// wide, 33px apart). Scaled with the stage since the overlay is fixed (not on
// the 1920 canvas).
export const VideoOverlayControls = styled.div`
  position: absolute;
  z-index: 30000;
  bottom: calc(28px * var(--stage-scale, 1));
  left: 50%;
  transform: translateX(-50%);
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: calc(33px * var(--stage-scale, 1));
`;

// Close circle for the overlay's bottom row (the fullscreen player keeps its
// own top-right VideoCloseButton, which must clear the native video controls).
export const VideoOverlayCloseButton = styled.div`
  cursor: pointer;
  width: calc(53px * var(--stage-scale, 1));
  height: calc(53px * var(--stage-scale, 1));
  border-radius: 50%;
  border: 1px solid #aaaaaa;
  background-image: url(${btFechar});
  background-repeat: no-repeat;
  background-position: center center;
  background-size: cover;
`;

// Round toggle that switches the gallery's videos between the thumbnail grid
// and the split view (list + player). Same circular treatment as the carousel
// zoom/close buttons; a flex child of VideoOverlayControls.
export const VideoViewToggle = styled.div`
  cursor: pointer;
  width: calc(53px * var(--stage-scale, 1));
  height: calc(53px * var(--stage-scale, 1));
  border-radius: 50%;
  border: 1px solid #aaaaaa;
  background-color: rgba(0, 0, 0, 0.45);
  display: flex;
  align-items: center;
  justify-content: center;

  svg {
    width: 46%;
    height: 46%;
    fill: #ffffff;
  }

  &:active {
    background-color: rgba(255, 255, 255, 0.18);
  }
`;

// Split view: scrollable thumb list on the left, player on the right. Sized in
// stage px (720 tall) so both panes are identical on Full HD and 4K. The list
// and the player are both height:100% of this row, so the list is exactly as
// tall as the player. Widths: 340 (list) + 24 (gap) + 1280 (player, 16:9 of
// 720) = 1644, inside the 1920 canvas.
export const VideoSplit = styled.div`
  display: flex;
  flex-direction: row;
  align-items: stretch;
  gap: ${sp(24)};
  height: ${sp(720)};
  /* clear the bottom control row (close + view toggle) */
  margin-bottom: ${sp(60)};
`;

export const VideoSplitList = styled.div`
  flex: 0 0 ${sp(340)};
  height: 100%;
  overflow-y: auto;
  -webkit-overflow-scrolling: touch;
  display: flex;
  flex-direction: column;
  gap: ${sp(10)};
  padding-right: ${sp(8)};
  ${darkScrollbar}
`;

// One row of the left list: small poster + caption. The row playing right now
// is marked .active.
export const VideoSplitItem = styled.div`
  cursor: pointer;
  user-select: none;
  flex: 0 0 auto;
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: ${sp(12)};
  padding: ${sp(8)};
  border-radius: ${sp(8)};
  background-color: rgba(255, 255, 255, 0.06);

  &.active {
    background-color: rgba(255, 255, 255, 0.2);
  }

  .thumb {
    position: relative;
    flex: 0 0 ${sp(140)};
    height: ${sp(79)};
    border-radius: ${sp(6)};
    overflow: hidden;
    background-size: cover;
    background-position: center;
    background-color: #000;
  }

  .thumb::after {
    content: "";
    position: absolute;
    left: 50%;
    top: 50%;
    transform: translate(-40%, -50%);
    width: 0;
    height: 0;
    border-style: solid;
    border-width: ${sp(10)} 0 ${sp(10)} ${sp(16)};
    border-color: transparent transparent transparent #ffffff;
    filter: drop-shadow(0 1px 2px rgba(0, 0, 0, 0.7));
  }

  .caption {
    font-family: var(--app-font-family, "DM Sans", sans-serif);
    font-weight: 500;
    font-size: ${sp(15)};
    line-height: 1.25;
    color: #ffffff;
    overflow: hidden;
    display: -webkit-box;
    -webkit-line-clamp: 2;
    -webkit-box-orient: vertical;
  }
`;

// 16:9 of the split's 720 height -> 1280 stage px wide. Fixing the width (vs a
// flexible fill) makes the player box exactly the video's visible area, so the
// list beside it matches the picture height, not a letterboxed container.
export const VideoSplitPlayer = styled.div`
  flex: 0 0 ${sp(1280)};
  height: 100%;
  min-width: 0;
  border-radius: ${sp(8)};
  overflow: hidden;
  background-color: #000;
  display: flex;
  align-items: center;
  justify-content: center;

  video {
    width: 100%;
    height: 100%;
    object-fit: contain;
    background: #000;
  }
`;

// Full-window overlay that shows a planta's external link in an iframe, so the
// link opens inside the kiosk window instead of a new tab/window there is no
// way to close on a touch screen. Same fixed/portal + .in fade pattern as
// VideoOverlay; sits just above it, and carries its own close button.
export const LinkOverlay = styled.div`
  pointer-events: none;
  position: fixed;
  inset: 0;
  width: 100vw;
  height: 100vh;
  z-index: 100002;
  background-color: #ffffff;
  opacity: 0;
  transition: opacity 0.3s ease-in-out;

  &.in {
    pointer-events: all;
    opacity: 1;
  }

  iframe {
    position: absolute;
    inset: 0;
    width: 100%;
    height: 100%;
    border: 0;
  }
`;
